import { Component, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { CompetitionService } from 'app/services/competition.service';
import { SharepointService } from 'app/services/sharepoint.service';
import { SharepointData } from '../../models/sharepoint-data';

@Component({
  selector: 'app-general-view',
  templateUrl: './general-view.component.html',
  styleUrls: ['./general-view.component.scss']
})
export class GeneralViewComponent implements OnInit {
  public imageUrl: string | null = null;
  constructor(
    private competitionService: CompetitionService,
    private sharepointService: SharepointService) {

  }

  ngOnInit() {

    this.competitionService
      .getCompetitionSelectedSubscriber()
      .subscribe((assetBackground) => {
        if (assetBackground) {
          const sharePointFile: SharepointData = Object.assign(assetBackground, {
            fileName: 'backgorund',
            mimeType: 'image/*',
          });

          this.sharepointService.downSharepointFile(sharePointFile)
            .subscribe((file) => {
              this.imageUrl = URL.createObjectURL(file.content);
            });
        }
      });
  }
}
